import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TimeRemainingCountdownComponent } from './time-remaining-countdown.component';

export const ngxTimeRemainingCountdownModule = angular.module('ngxTimeRemainingCountdownModule', [])
	.directive('ngxTimeRemainingCountdown', downgradeComponent({ component: TimeRemainingCountdownComponent }))
	.name;
